export default "__VITE_ASSET__86f8ff82__"